<div class="fake-encapsulation">
  <div [style.display]="'block'" [style.height.px]="(isPhablet$ | async) ? 300 : 400">
    <div #geoisMap id="geoisMap" class="geois-map"></div>
  </div>
  <div
    class="dummy_container"
    [class.placeholder-small-img]="!!errorMessage"
    [style.display]="showMap === false ? 'block' : 'none'"
    [style.height.px]="(isPhablet$ | async) ? 300 : 400"
  >
    <div class="placeholder" [class.map-loading]="!errorMessage">
      <img
        class="placeholder-img"
        alt="Karte wird geladen..."
        src="assets/images/map-default-blur.png"
      />
    </div>
    <div class="error" [style.display]="!!errorMessage ? 'block' : 'none'">
      {{ errorMessage }}
    </div>
  </div>
</div>
